import { Size } from '../../typings/common';

const CREATIVE_SIZE_BOX_MAX_SIZE = 62;

export const calculateFormatPreviewStyleSize = (width: number, height: number): Size => {
    const aspect = width / height;

    if (width > height) {
        return {
            width: CREATIVE_SIZE_BOX_MAX_SIZE,
            height: CREATIVE_SIZE_BOX_MAX_SIZE / aspect
        };
    }

    return {
        width: CREATIVE_SIZE_BOX_MAX_SIZE * aspect,
        height: CREATIVE_SIZE_BOX_MAX_SIZE
    };
};
